export class MACCConstants {
  public static PlaceholdersAndTitles = {
    MACC: 'MACC',
    BasicInformation: 'BASIC INFORMATION',
    RequestorInformation: 'REQUESTOR INFORMATION',
    AdditionalInformation: 'ADDITIONAL INFORMATION',
    OppurtunityInformation: 'OPPORTUNITY INFORMATION',
    AEAlias: 'AE Alias',
    CEAlias: 'CE Alias',
    SSSPAlias: 'SSSP Alias',
    AEName: 'AE Name',
    CEName: 'CE Name',
    SSSPName: 'Services Seller Name',
    RemoveAEAlias: 'remove Accountable Exec',
    CustomerName: 'Customer Name',
    EnterCustomerName: 'Enter Customer Name',
    OpportunityRevenueSize: 'MACC Opportunity Revenue Size (In USD)',
    EnterOpportunityRevenueSize: 'Enter MACC Opportunity Revenue Size',
    DurationInMonths: 'MACC Duration in Months',
    EnterDurationInMonths: 'Enter MACC Duration in Months',
    AnnualizedMACCValue: 'Annualized MACC Value',
    OperationgUnit: 'Operating Unit',
    MACCExpectedMinimumSupportAdoption: 'Expected Minimum Unified Adoption %',
    MACCProposedSupportAdoption: 'Proposed Enhanced Solutions Adoption %',
    MACCProposedSupportAdoptionInfo:
      'Please use the MACC Purple Empowerment Estimator tool to determine Minimum Unified Adoption %',
    MACCPurpleEstimator: 'MACC Adoption Estimator',
    MACCPurpleEstimatorInfo:
      'Please use the MACC Purple Empowerment Estimator tool to determine Proposed Unified Adoption %',
    MACCReasonforException: 'Reason for Exception',
    MACCConfirmSupportMACCConsultStage:
      'Confirm if the Unified Specialist has been engaged early in MACC sales motion during Listen and Consult stage',
    MACCCustomerSupportAdoption:
      "How the customer's current Enhanced Solutions adoption represents no risk to customer nor Microsoft (e.g.,adequate internal or partner enablement and proactive services)",
    MACCUnifieldAdoption:
      'How the Consumption Plan will be successfully executed without Unified or without minimum Enhanced Solutions adoption',
    Maccjustification: 'If MACC and Unified agreement are not co-terminus, provide justification',
    MACCExceptionApprover: 'Exception Approver',
    RemoveExceptionApprover: 'Remove Exception Approver',
    MACCNotificationsent: 'Stakeholder(s) to be notified',
    MACCOptionalAreaSupportLead: 'Optional Area Support Lead',
    EnterValue: 'Enter Value',
    EnterTextHere: 'Enter text here',
    RemoveRequestor: 'Remove Requestor',
    select: 'Select',
    SelectReasonForException: 'Select Reason for Exception',
    RequestorManager: "Requestor's Manager",
    AEAliasMandatory: 'AE Name is mandatory',
    RemoveCEAlias: 'Remove CE Alias',
    RemoveSSSPAlias: 'Remove SSSP Alias',
    ExceptionApprover: 'Exception Approver',
    ExceptionApproverMandatory: 'Exception Approver is mandatory',
    NotificationSentMandatory: 'Notification Sent is/are mandatory',
    Attachments: 'Attachments',
    AttachmentsInfo:
      'Please include a copy of the MACC Purple Empowerment Minimum Adoption Estimator for this deal, as well as any other relevant attachments.',
    MaccOppID: 'MACC Opportunity ID',
  };

  public static MacctabPath = '&tab=MACC';

  public static UATFields = {
    AEAlias: 'Custom.MACC_AE_Alias',
    CEAlias: 'Custom.MACC_CE_Alias',
    SSSPAlias: 'Custom.MACC_SSSP_Alias',
    DurationInMonths: 'Custom.MACC_Duration_in_Months',
    MACCExpectedMinimumSupportAdoption: 'Custom.MACC_ExpectedMin_Support_Adoption',
    MACCProposedSupportAdoption: 'Custom.MACC_Proposed_Support_Adoption',
    MACCOperatingUnit: 'Custom.MACC_Operating_Unit',
    MACCAnnualizedValue: 'Custom.MACC_Annualized_Value',
    MACCProposedUnifiedContractRevenue: 'Custom.MACC_Proposed_Unified_Contract_Revenue',
    MACCProposedUnifiedRevenue: 'Custom.MACC_Proposed_UnifiedRevenue',
    MACCProposedUnifiedDurationInMonths: 'Custom.MACC_Proposed_Unified_Duration_In_Months',
    MACCAnnualizedUnifiedRevenue: 'Custom.MACC_Annualized_Unified_Revenue',
    MACCReasonforException: 'Custom.MACC_Reason_for_Exception',
    MACCExceptionApprover: 'Custom.MACC_Exception_Approver',
    MACCNotificationsent: 'Custom.MACC_Notification_tobe_sent',
    MACCOptionalAreaSupportLead: 'Custom.MACC_Optional_Area_Support_Lead',
    MACCIS_Sales_Engaged: 'Custom.MACC_IS_Sales_Engaged',
    MACCCustomerHas_UnifiedAgreement: 'Custom.MACC_Customer_Has_UnifiedAgreement',
    MACCCustomers_current_Support_adoption: 'Custom.MACC_Customers_current_Support_adoption',
    MACCConsumption_Plan: 'Custom.MACC_Consumption_Plan',
    MACCand_Support_agreement: 'Custom.MACC_and_Support_agreement_sent',
    MACCRequestorManager: 'Custom.MACC_Requestor_Manager',
    NodeName: 'System.NodeName',
  };

  public static ErrorMessages = {
    ExpectedMinimumSupportAdoptionMandatory: 'Expected Minimum Unified Adoption is mandatory',
    ProposedSupportAdoptionMandatory: 'Proposed Support Adoption is mandatory',
    ExpectedMinimumSupportAdoptionNumeric: 'Expected Minimum Unified Adoption is mandatory',
    ProposedSupportAdoptionNumeric: 'Proposed Support Adoption is mandatory',
    ReasonForExceptionMandatory: 'Reason for Exception is mandatory',
    MaccOpportunityMandatory: 'MACC Opportunity ID is mandatory',
    MaccInvalidOpportunityID: 'MACC Invalid Opportunity ID',
  };

  public static AnnualizedMACCValues: { [key: number]: number } = {
    500000: 12,
    5000000: 11,
    15000000: 10,
    30000000: 8,
    50000000: 7,
    100000000: 4,
  };
}
